module.exports = __webpack_public_path__ + "img/limit.402224eb.svg";